export const CANCEL_REASON_LABELS: Record<string, string> = {
  ANY: 'Any',
  NATURAL: 'Natural',
  ON_RESTART: 'On Restart',
  BY_ADMIN: 'By Admin',
  BY_USER: 'By User',
  PROVIDER: 'By Provider',
  ON_DISCONNECT: 'On Disconnect',
  OTHER: 'Other',
};

export function getCancelReasonLabel(reason: string): string {
  return CANCEL_REASON_LABELS[reason] ?? reason;
}
